import React from "react";
import feedstyles from "src/Assets/css/home/feedpost.module.css";
import sampledialogcancel from "src/Assets/images/Add.png";
import { Modal, Box } from "@mui/material";

const FileSizeAlertModal = ({ open, onClose }) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="file-size-alert-title"
      aria-describedby="file-size-alert-description"
      sx={{ zIndex: 2200 }}
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          backgroundColor: "white",
          padding: "20px",
          borderRadius: "8px",
          outline: "none",
          boxShadow: 24,
          minWidth: 300,
        }}
      >
        <div className={feedstyles.sampledialogcountandcancel}>
          <p>
            <b>File Size Too Large</b>
          </p>
          <a onClick={onClose}>
            <img src={sampledialogcancel} alt="" />
          </a>
        </div>

        <p style={{ marginBottom: "18px" }}>
          The selected file is larger than <b>2 MB</b>.  
          Please choose a smaller file.
        </p>

        <button
          onClick={onClose}
          className={feedstyles.dialogdeletebutton}
          style={{ width: "20%" }}
        >
          OK
        </button>
      </Box>
    </Modal>
  );
};

export default FileSizeAlertModal
